import { Icon, IconKey } from '@/shared/components';
import { FieldCardToggle, type CardToggleOption } from '@/shared/components/form/field-card-toggle';
import type { SplitType } from '@/shared/types';

const SPLIT_OPTIONS: CardToggleOption<SplitType>[] = [
  { value: 'personal', icon: IconKey.User, label: 'Personal', description: "One person's expense" },
  { value: 'equal', icon: IconKey.Users, label: 'Equal', description: 'Split 50/50' },
  { value: 'custom', icon: IconKey.SlidersHorizontal, label: 'Custom', description: 'Set amounts' },
];

interface SplitModeSelectorProps {
  selectedType: SplitType;
  onSelect: (type: SplitType) => void;
  disabled?: boolean;
}

export function SplitModeSelector({ selectedType, onSelect, disabled }: SplitModeSelectorProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Icon icon={IconKey.Users} size={14} className="text-muted-foreground" />
        <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          How is this shared?
        </span>
      </div>

      <FieldCardToggle
        options={SPLIT_OPTIONS}
        value={selectedType}
        onValueChange={onSelect}
        disabled={disabled}
        variant="vertical-prominent"
        colorScheme="accent"
      />
    </div>
  );
}
